// Los textos de la pagina de credenciales del rival (spec 2026-10-15 §5). Puro: sin Supabase.
import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import { parseLocalDate } from './dateUtils'

// Las fotos son URLs que caducan a los 10 minutos (VIGENCIA_URL_S de fotos-roster): la pagina se
// vuelve a cargar a los 9.
export const RECARGA_MS = 9 * 60 * 1000

// '2026-10-18' -> '18 de octubre'. Sin fecha, ''.
export const fechaCorta = (iso) => {
  const d = iso ? parseLocalDate(iso) : null
  return d ? format(d, "d 'de' MMMM", { locale: es }) : ''
}

const NO_LISTO = 'El equipo rival todavía no puede mostrar sus credenciales.'
const INACTIVO = 'Este partido ya no está activo.'

const CERRADAS = {
  antes: ({ abre }) => (abre
    ? `Se abren el ${fechaCorta(abre)}, 2 días antes del partido.`
    : 'Se abren 2 días antes del partido.'),
  despues: () => 'Se cerraron al terminar el día del partido. Si hay una protesta, la revisa la organizadora.',
  sin_fecha: () => 'Se abren 2 días antes del partido, cuando la organizadora le ponga fecha.',
  sin_rival: () => 'Todavía no se sabe contra quién es este partido.',
  rival_no_aprobado: () => NO_LISTO,
  rival_sin_convenio: () => NO_LISTO,
  cancelado: () => INACTIVO,
  pospuesto: () => 'El partido se pospuso. Se abren 2 días antes del partido, cuando la organizadora lo reprograme.',
  equipo_no_aprobado: () => 'Tu equipo no está aprobado en este torneo.',
  sin_convenio_propio: () => 'Tu club tiene que aceptar el convenio 1.1 para ver las credenciales del rival. Lo acepta quien administra el club en MYKLUBB.',
  torneo_cerrado: () => INACTIVO,
}

// Por que estan cerradas, segun el motivo que manda credenciales_rival.
export const mensajeCerradas = (motivo, { abre } = {}) => {
  const texto = CERRADAS[motivo]
  return texto ? texto({ abre }) : 'Las credenciales no están disponibles.'
}

export const textoVigencia = (cierra) =>
  `Visibles hasta el ${fechaCorta(cierra)}. Solo para verificar la identidad en este partido.`
